const getters = {
  isMultiplePayments: (state) => state.type === 'multiplo',
  cardType: (state) => state.type,
  cardBrand: (state) => state.brand,
  selectedCardType: (state) => state.selectedCardType,
  requestingInfos: (state) => state.requestingInfos,
}

export default getters
